import script from "./Register.vue?vue&type=script&setup=true&lang=js"
export * from "./Register.vue?vue&type=script&setup=true&lang=js"

import "./Register.vue?vue&type=style&index=0&id=e289b08c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e289b08c"]])

export default __exports__